import CityPageTemplate from "../city-template/CityPageTemplate";
import { visaliaConfig } from "./data";

export default function VisaliaPage() {
  return <CityPageTemplate config={visaliaConfig} />;
}